import { LOCALES } from '../constants';

export default {
  [LOCALES.ARABE]: {
    // new one
    'pagination':'ترقيم الصفحات',
    'header':'رؤوس',
    'toolbar':'شريط الأدوات',
    'body':'هيكل',
    // Side Menue
    "Project Management":"إدارة المشاريع",
    'Dashboard':'لوحة القيادة',
    'Calendar':'تقويم اليوم',
    'Kanban':'كانبان',
    'TimeLine':'تايم لين',
    'Gantt':'ڨانت',
    'Notifications':'إخطارات',
    'User Profile':'مشرف',
    // Create Project selector
    'Project type':'نوع المشروع',
    // Spreadsheet Column
    'Tasks ERP':' تخطيط موارد المؤسسة',
    'Hardware':'المعدات',
    'Source':'المعرّف',
    'Start':'البدء',
    'Subject':'الموضوع',
    'Assigned To':'المكلف',
    'Due Date':'النهاية',
    'Active?':'?فعال',
    'Status':'الحالة',
    'Progress':'التقدم',
    'Priority':'الأولوية',
    'Notes':'الملاحضات',
    // Spreadsheet Action
    'Show last Modified':'إظهار آخر تعديل',
    'Import Rows from csv':'csv'+'استيراد صفوف من ملف',
    'Toogle single cell editing':'تبديل تحرير خلية واحدة',
    'Delete multipe':'حذف متعدد',
    'Remove All Selected Tasks':'إزالة كافة المهام المحددة',
    'Export':'تحميل',
    'Actions':'أجراءات',
    'no record to display':'لا يوجد سجل للعرض',
    'Add':' إضافة',
    "Add Task":"إضافة مهام",
    'Delete':'حذف',
    'Permanent delete':'حذف دائم',
    'Edit':'تعديل',
    'Are you sure delete this row?':'هل أنت متأكد من حذف هذا الصف؟',
    'Cancel':'إلغاء',
    'Save':'تسجيل',
    'Search':'بحث',
    'rows':'الصفوف',
    'First page':'الصفحة الأولى',
    'Previous':'السابق',
    'Next':'التالى',
    'Last page':'آخر صفحة',
    'of':'من',
    'Export to CSV':'تصدير إلى CSV',
    'Export to PDF':'تصدير إلى PDF',
    // csv Sync
    'Sync header field here with mode':'Sync header field here with mode',
    // ProjectKPI
    'Project Road Map':'خريطة طريق المشروع',
    'Team member: ':'أعضاء الفريق: ',
    'Tasks Status':'حالة المهام',
    'Tasks Average Progress':'متوسط تقدم المهام',
    'Remaining days :':'الأيام المتبقية  :',
    'Task completed':'المهام المنجزة',
    'Assigned':'المخصصة',
    'InProgress':'تقدم',
    'InReview':'مراجعة',
    'Completed':'منجز',
    'Suspended':'معلق',
    // Project Selector
    'Modify':'تعديل',
    'Add project':'إضافة مشروع',
    'Project':'المشروع',
    'Select project':'حدد المشروع',
    'Project owner':'مدير المشروع',
    'Collaborator':'متعاون',
    'Not allowed for guest':'غير مسموح للضيف',
    'Delete forever ?':'الحذف للأبد ?',
    // Cash financial Scenario Selector
    'Scenario':'السيناريو المالي',
    'Select scenario':'حدد السيناريو',
    'Scenario owner':'صاحب السيناريو',
    'Add scenario':'إضافة سيناريو',
    // Cash financial Scenario Selector
    "Category":"الفئة",
    "Date":"تاريخ",
    "Amount":"مقدار",
    "Descriptions":"تفصيل",
    "Income":"دخل",
    "Expense":"نفقة",
    "Balance":"الرصيد",
    "Add Income":"إضافة دخل",
    "Add Expense":"إضافة نفقة",
    "Daily Flow":"التدفق اليومي",
    "Annual Report":"Annual Report",
    "Treasury":"خزينة",
    "Today":"Today",
    "Actual":"الحالي",
    "Actual Cash Flow":"التدفقات النقدية الحالية",
    "Daily":"اليومي",
    "Monthly":"شهري",
    // Notification Page
    'Activity':'النشاطات',
    'Today Activity':'أعمال ليوم',
    'No task for Today, continue in actuel tasks':'لايوجد أعمال لهذا اليوم، استمر في الأعمال السابقة',
    // Others
    'Close':'أغلق',
    'Submit':'حفظ',
    'ok':'موافق',
    'available':'متاح',
    'Sign out':'Sign out',
    'Home':'Home',
    'organisation':'organisation',
    'Welcome':'مرحبا',
    'Created':'تم إنشاء',
    'Updated':'تم تعديل',
    'email':'البريد الإلكتروني',
    'Address':'العنوان',
    'Title':'عنوان',
    'id':'المعرّف',
    'Id':'المعرّف',
    'New':'اضف جديد	',
    // other ERP Module/Departement
    'CRM':'إدارة علاقات العملاء',
    "Contact Lists":"قوائم الاتصال",
    "Activities":"أنشطة",
    "Deals":"صفقات",
    "clients":"العملاء",
    "companies":"شركات",
    "start":"بداية",
    "finish":"نهاية",
    "type":"نوع",
    "pipeline":"مخططة",
    'Cash Flow':'التدفقات النقدية',
    'Test Components':'Test Components',
  },
};
